import styled from '@emotion/styled';
import { CheckIcon } from 'components';
import colors from 'lib/colors';
import { useTranslation } from 'react-i18next';

const TrainingLegend = () => {
  const { t } = useTranslation();

  return (
    <>
      <Legend>
        <CheckIcon
          backgroundColor={colors.white}
          foregroundColor={colors.success}
        />
        <LegendText>
          {t('matchView.succesfulllyCompleted', 'Úspěšně odehráno')}
        </LegendText>
      </Legend>
      <Legend>
        <CheckIcon backgroundColor={'#B5B5B5'} foregroundColor={colors.gray} />

        <LegendText>{t('matchView.uncompleted', 'Potřeba splnit')}</LegendText>
      </Legend>
    </>
  );
};

export default TrainingLegend;

export const Legend = styled.div`
  display: flex;
  margin-top: 16px;
  justify-content: center;
  line-height: 1.25;
  margin-left: 1em;
  margin-right: 1em;
`;
const LegendText = styled.div`
  color: white;
  justify-content: center;
  margin-left: 8px;
`;
